module.exports = __webpack_public_path__ + "img/biaozhun-dingbu.c30fb059.svg";